export function getLatestSubmissionNumber(record) {
  if (!record) return "N/A";

  if (record.submission_number) return record.submission_number;

  if (Array.isArray(record.submission_numbers) && record.submission_numbers.length) {
    return record.submission_numbers[record.submission_numbers.length - 1];
  }

  return "N/A";
}
